import authRouter from "./auth.router";

import { LoginFormComponent } from "./components/login-form/login-form.component";
import { RegisterFormComponent } from "./components/register-form/register-form.component";
import { PageAuthComponent } from "./components/page-auth/page-auth.component";
import { ResetPasswordFormComponent } from "./components/reset-password-form/reset-password-form.component";


export var authModule = angular.module('gplans.auth', []).
component('pageAuth', PageAuthComponent).
component('loginForm', LoginFormComponent).
component('registerForm', RegisterFormComponent).
component('resetPasswordForm', ResetPasswordFormComponent).

config(authRouter);